import type { Paginated } from '@worki/shared';

/** Finish reading the captured filter before replacing the user's selection. */
export async function collectPageKeys<T>(readPage:(page:number)=>Promise<Paginated<T>>,key:(row:T)=>string):Promise<string[]> {
  const ids=new Set<string>();
  for(let page=1;;page++) {
    const result=await readPage(page);
    if(result.page!==page || result.pageSize<1)throw new Error('Invalid selection page');
    result.items.forEach(row=>ids.add(key(row)));
    if(page*result.pageSize>=result.total)return [...ids];
    if(!result.items.length)throw new Error('Selection changed while loading');
  }
}

/** Preserve row-level refusals; a failed batch must never count as success. */
export async function applySelectedBatches(ids:readonly string[],apply:(ids:string[])=>Promise<{ok:number;failed:string[]}>,limit:number):Promise<{ok:number;failed:string[]}> {
  if(!Number.isInteger(limit)||limit<1)throw new Error('Invalid batch size');
  const result={ok:0,failed:[] as string[]};
  const unique=[...new Set(ids)];
  for(let offset=0;offset<unique.length;offset+=limit) {
    const batch=unique.slice(offset,offset+limit);
    try {
      const outcome=await apply(batch);
      result.ok+=outcome.ok;result.failed.push(...outcome.failed);
    }catch {result.failed.push(...batch);}
  }
  return result;
}
